import React, { Children, useState } from 'react';
import * as S from './Card.styles';

const Card = ({ children }) => {

  return (
    <S.Wrap>
      {children}
    </S.Wrap>
  );
};

export default Card;
